import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function FailedSolutions() {
  const reasons = ["Las dietas de 'fibra extrema' irritan más un intestino que ya está sensible.", "Los productos '0% azúcar' suelen estar llenos de edulcorantes que fermentan en tu panza.", 'Los planes detox de jugos te dejan con hambre, mal humor y efecto rebote inmediato.', 'El estrés de la rutina argentina bloquea tu digestión antes de que des el primer bocado.', 'Te faltaba una lista de compras realista para el Coto, el Carrefour o el chino de la vuelta.'];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-20 px-4 bg-white" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-4">
            Por qué lo que probaste no funcionó
          </h2>
          <p className="text-lg text-brown/70" data-id="element-5">
            No es falta de voluntad, es falta de la estrategia correcta.
          </p>
        </motion.div>

        <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-6" data-id="element-6">
          {reasons.map((reason, index) => <motion.li key={index} variants={itemVariants} className="flex items-start gap-4 p-4 rounded-2xl hover:bg-cream/50 transition-colors duration-300" data-id="element-7">
              <XCircleIcon className="w-6 h-6 text-terracotta flex-shrink-0 mt-1" data-id="element-8" />
              <span className="text-lg text-brown/90 leading-relaxed" data-id="element-9">
                {reason}
              </span>
            </motion.li>)}
        </motion.ul>
      </div>
    </section>;
}